// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Ljg8","title":"Info_title__1qc0m","links":"Info_links__1HJMu","link":"Info_link__3X2Ty","logo":"Info_logo__3CCVs"};